import { useEffect } from 'react';
import { useCanvasSession } from '../contexts/CanvasSessionContext';
import { useUiOverlay } from '../contexts/useUiOverlay';

/**
 * On reload, `homeVisible` defaults true while a persisted session may still
 * be active — that unmounts the canvas and looks like a reset to `/`. Hide
 * home whenever session phase is non-idle (including after hydration from
 * idle → onboarding/complete).
 */
export function useSessionHomeSync(): void {
  const { session } = useCanvasSession();
  const { hideHome } = useUiOverlay();

  useEffect(() => {
    if (session.phase !== 'idle') {
      hideHome();
    }
  }, [session.phase, hideHome]);
}

/** Mount helper — call from App shell. */
export function SessionHomeSyncMount(): null {
  useSessionHomeSync();
  return null;
}
